import React from 'react';

const Home = () => (
  <>
    <section className="home__container">
      <h1 className="home__title">Ubiquiti checklist app</h1>
      <p className="home__subtitle">
        {`Welcome to my Reminders Application which is deployed using Netlify for the client side and Heroku for the server.
        The client side is built with React and typescript and the server side is built with Express, MongoDB and socket.io.`}
      </p>
    </section>
  </>
);

export default Home;
